import { useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { Address } from "viem";

import { convertHexToBech32 } from "shared/web3/utils";

import { DelegatorDelegations200 } from "./gen";

type DelegationResponse = Exclude<
  DelegatorDelegations200["delegation_responses"],
  undefined
>;

export type Delegation = Exclude<
  DelegationResponse[number]["delegation"],
  undefined
>;
export type DelegationBalance = Exclude<
  DelegationResponse[number]["balance"],
  undefined
>;

type Params = {
  address?: Address;
};

export const useDelegationsQuery = (params: Params) => {
  return useQuery({
    queryKey: ["cosmos", "staking", "delegations", params],
    queryFn: async () => {
      invariant(params.address);
      const bech32AccountAddress = convertHexToBech32(params.address);
      const response = await fetch(
        `/cosmos-api/cosmos/staking/v1beta1/delegations/${bech32AccountAddress}`
      );

      const data: DelegatorDelegations200 = await response.json();

      return data;
    },
  });
};
